"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbWithDetail = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _models = require("../../models");
var _api = require("../../models/api");
var _Loading = require("../Loading");
var _jsxRuntime = require("react/jsx-runtime");
const imagePreviewThumbSize = 80;
const imagePreviewDetailSize = 500;
const StyledDialogContent = (0, _mui.styled)(_mui.DialogContent)(({
  theme
}) => ({
  position: 'relative',
  minWidth: '60px',
  minHeight: '40px'
}));
const CloseButton = (0, _mui.styled)(_components.IconButton)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  right: '6px'
}));
const StyledAvatar = (0, _mui.styled)(_mui.Avatar)(({
  theme
}) => ({
  width: '80px',
  height: '80px',
  borderRadius: 0,
  background: 'transparent',
  color: theme.palette.text.primary,
  textDecoration: 'none',
  cursor: 'pointer'
}));
const DocumentIcon = (0, _mui.styled)(_icons.Document)(({
  theme
}) => ({
  fontSize: '38px'
}));
const ThumbWithDetail = props => {
  const {
    fileName,
    documentId
  } = props;
  const [detailOpened, setDetailOpened] = (0, _react.useState)(false);
  const [imageThumb, setImageThumb] = (0, _react.useState)({});
  const [imageDetail, setImageDetail] = (0, _react.useState)({});
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const customerId = registrationData?.customerId ?? null;
  const documentThumbUrl = (0, _api.useDocumentThumb)(customerId, documentId, {
    height: imagePreviewThumbSize,
    width: imagePreviewThumbSize
  });
  const documentThumbDetailUrl = (0, _api.useDocumentThumbDetail)(customerId, documentId, {
    height: imagePreviewDetailSize,
    width: imagePreviewDetailSize
  });
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const mountOrUpdate = (0, _react.useCallback)(() => {
    if (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always truthy we need this conditon
    imageThumb && !imageThumb[documentId] && /\.(jpg|jpeg|png|bmp)$/gi.test(fileName) && documentId > 0 && customerId) {
      const currentImages = {};
      setImageThumb({
        ...currentImages,
        [documentId]: documentThumbUrl
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed other property
  }, [customerId, documentId, fileName, imageThumb]);
  (0, _react.useEffect)(() => {
    mountOrUpdate();
  }, [customerId, mountOrUpdate]);
  const getDetailImage = fileNameProperty => {
    const imgUrl = imageDetail[documentId];
    if (imgUrl && detailOpened) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: imgUrl,
        alt: fileNameProperty
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {});
  };
  const handleOpenDetail = event => {
    event.preventDefault();
    setDetailOpened(true);

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always truthy we need this conditon
    if (imageDetail && !imageDetail[documentId] && customerId) {
      const currentImages = {};
      setImageDetail({
        ...currentImages,
        [documentId]: documentThumbDetailUrl
      });
      // await fetchImageDetail(customerId, documentId);
    }
  };
  const handleDetailClose = () => {
    setDetailOpened(false);
  };
  const getAvatar = () => {
    if (/\.(jpg|jpeg|png|bmp)$/gi.test(fileName) && documentId > 0) {
      const thumb = imageThumb[documentId];
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
        title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.showImage,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.showImage
        }),
        onClick: handleOpenDetail,
        ...getTestIdProps('thum-with-detail-tooltip-open-detail'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAvatar, {
          src: thumb ?? ''
        })
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(DocumentIcon, {});
  };
  const avatar = getAvatar();
  const detailImage = getDetailImage(fileName);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [avatar, /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
      open: detailOpened,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.DialogTitle, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CloseButton, {
            onClick: () => handleDetailClose(),
            variant: "text",
            color: "default",
            ...getTestIdProps('thum-with-detail-bt-close-detail'),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {})
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDialogContent, {
          children: detailImage
        })]
      })
    })]
  });
};
exports.ThumbWithDetail = ThumbWithDetail;